// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A4CmK0c3QiGwJGOQIayw{justify-content:space-between;align-items:center;padding:8px;display:flex}.ApKoQWCtJMzrASAdeBK5{color:var(--content-primary-primary);font-size:13px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `A4CmK0c3QiGwJGOQIayw`,
	"label": `ApKoQWCtJMzrASAdeBK5`
};
export default ___CSS_LOADER_EXPORT___;
